import { PropTypes } from 'prop-types';
import React, { useRef } from 'react';

import { FrequencyLineChart } from '@ge/components/charts';
import { generateVibration } from '@ge/components/charts/frequency-line-chart/mocks';

const MeshVibrationChart = ({ alignChevronLeft, className, onChevronClick, large, title }) => {
  const data = useRef(generateVibration(310));

  return (
    <FrequencyLineChart
      alignChevronLeft={alignChevronLeft}
      className={className}
      data={data.current}
      large={large}
      onChevronClick={onChevronClick}
      title={title}
      xAxisMax={350}
      xInterval={100}
      yInterval={20}
      tickPositions={[100, 200, 300]}
      startOnTick={75}
      type="category"
    />
  );
};

MeshVibrationChart.propTypes = {
  alignChevronLeft: PropTypes.bool,
  className: PropTypes.string,
  onChevronClick: PropTypes.func,
  large: PropTypes.bool,
  title: PropTypes.string,
};

MeshVibrationChart.defaultProps = {
  alignChevronLeft: false,
  className: '',
  onChevronClick: null,
  large: false,
  title: null,
};

export default MeshVibrationChart;
